export default __webpack_public_path__ + "static/1260-148080aed1dcd814d61bc541e1e05346.gif";